import { ReduxDispatch } from "models/ReduxProps";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import DocumentsEffect, {
    ISignCancelRequest,
    ISignRequest,
    ISignStatusRequest,
    IUploadDocumentsRequest,
} from "./DocumentsEffect";
import DocumentsActionModel from "./models/DocumentActionModel";
import DocumentsDownloadActionModel from "./models/DocumentsDownloadActionModel";
import DocumentsInfoModel from "./models/DocumentsInfoModel";
import DocumentsSignStatusModel from "./models/DocumentsSignStatusModel";
import InfoDocumentsModel from "./models/InfoDocumentsModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | DocumentsInfoModel
    | DocumentsActionModel
    | DocumentsDownloadActionModel
    | DocumentsSignStatusModel
    | InfoDocumentsModel
    | Blob;

export default class DocumentsAction {
    public static readonly REQUEST_DOCUMENTI_INFO_GET: string = "DocumentsAction.REQUEST_DOCUMENTI_INFO_GET";
    public static readonly REQUEST_DOCUMENTI_INFO_GET_FINISHED: string =
        "DocumentsAction.REQUEST_DOCUMENTI_INFO_GET_FINISHED";

    public static readonly REQUEST_DOCUMENT_UPLOAD: string = "DocumentsAction.REQUEST_DOCUMENT_UPLOAD";
    public static readonly REQUEST_DOCUMENT_UPLOAD_FINISHED: string =
        "DocumentsAction.REQUEST_DOCUMENT_UPLOAD_FINISHED";

    public static readonly REQUEST_DOCUMENT_DELETE: string = "DocumentsAction.REQUEST_DOCUMENT_DELETE";
    public static readonly REQUEST_DOCUMENT_DELETE_FINISHED: string =
        "DocumentsAction.REQUEST_DOCUMENT_DELETE_FINISHED";

    public static readonly REQUEST_DOCUMENT_GENERATE: string = "DocumentsAction.REQUEST_DOCUMENT_GENERATE";
    public static readonly REQUEST_DOCUMENT_GENERATE_FINISHED: string =
        "DocumentsAction.REQUEST_DOCUMENT_GENERATE_FINISHED";

    public static readonly REQUEST_DOCUMENT_DOWNLOAD: string = "DocumentsAction.REQUEST_DOCUMENT_DOWNLOAD";
    public static readonly REQUEST_DOCUMENT_DOWNLOAD_FINISHED: string =
        "DocumentsAction.REQUEST_DOCUMENT_DOWNLOAD_FINISHED";

    public static readonly REQUEST_SIGN: string = "DocumentsAction.REQUEST_SIGN";
    public static readonly REQUEST_SIGN_FINISHED: string = "DocumentsAction.REQUEST_SIGN_FINISHED";

    public static readonly REQUEST_SIGN_STATUS: string = "DocumentsAction.REQUEST_SIGN_STATUS";
    public static readonly REQUEST_SIGN_STATUS_FINISHED: string = "DocumentsAction.REQUEST_SIGN_STATUS_FINISHED";

    public static readonly REQUEST_SIGN_CANCEL: string = "DocumentsAction.REQUEST_SIGN_CANCEL";
    public static readonly REQUEST_SIGN_CANCEL_FINISHED: string = "DocumentsAction.REQUEST_SIGN_CANCEL_FINISHED";

    public static readonly RESET_DOCUMENTS: string = "DocumentsAction.RESET_DOCUMENTS";

    public static getDocumentsInfo(idEstimateRequest: number, idEstimate: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<DocumentsInfoModel>(
                dispatch,
                DocumentsAction.REQUEST_DOCUMENTI_INFO_GET,
                DocumentsEffect.getDocumentsInfo,
                idEstimateRequest,
                idEstimate
            );
        };
    }

    public static uploadDocument(request: IUploadDocumentsRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<DocumentsActionModel>(
                dispatch,
                DocumentsAction.REQUEST_DOCUMENT_UPLOAD,
                DocumentsEffect.uploadDocument,
                request
            );
        };
    }

    public static deleteDocument(request: IUploadDocumentsRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<InfoDocumentsModel>(
                dispatch,
                DocumentsAction.REQUEST_DOCUMENT_DELETE,
                DocumentsEffect.deleteDocument,
                request
            );
        };
    }

    public static generateDocument(request: IUploadDocumentsRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<DocumentsActionModel>(
                dispatch,
                DocumentsAction.REQUEST_DOCUMENT_GENERATE,
                DocumentsEffect.generateDocument,
                request
            );
        };
    }

    public static downloadDocument(request: IUploadDocumentsRequest, progressHandler: (progress: number) => void): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<Blob>(
                dispatch,
                DocumentsAction.REQUEST_DOCUMENT_DOWNLOAD,
                DocumentsEffect.downloadDocument,
                request,
                progressHandler
            );
        };
    }

    public static downloadStaticDocument(
        request: IUploadDocumentsRequest,
        progressHandler: (progress: number) => void
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<Blob>(
                dispatch,
                DocumentsAction.REQUEST_DOCUMENT_DOWNLOAD,
                DocumentsEffect.downloadStaticDocument,
                request,
                progressHandler
            );
        };
    }

    public static signDocument(request: ISignRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<DocumentsSignStatusModel>(
                dispatch,
                DocumentsAction.REQUEST_SIGN,
                DocumentsEffect.sign,
                request
            );
        };
    }

    public static signStatusDocument(request: ISignStatusRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<DocumentsSignStatusModel>(
                dispatch,
                DocumentsAction.REQUEST_SIGN_STATUS,
                DocumentsEffect.signStatus,
                request
            );
        };
    }

    public static signCancelDocument(request: ISignCancelRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<DocumentsSignStatusModel>(
                dispatch,
                DocumentsAction.REQUEST_SIGN_CANCEL,
                DocumentsEffect.signCancel,
                request
            );
        };
    }

    public static resetDocuments(): any {
        return ActionUtility.createAction(DocumentsAction.RESET_DOCUMENTS);
    }
}
